const pageNameKey = "addServiceUserDrawerModal";

export const addServiceUserDrawerModalEn = {
  [pageNameKey]: {
    addServiceUserTitle: "Add API User",
    serviceUserUsernameLabel: "Service username",
    serviceUserUsernameInputPlaceholder: "Enter service username",
    serviceUserNameLabel: "Name",
    serviceUserNameInputPlaceholder: "Enter name",
    serviceUserDescriptionLabel: "Description",
    serviceUserDescriptionInputPlaceholder: "Enter description",
    createServiceUserButtonText: "Create service user",
    cancelButtonText: "Cancel",
    rolesWarningText: "Please assign at least one role to the service user.",
    inputsCheckWarningText: "Please fix the following fields",
    userCreatedSuccessText: "Service user created successfully",
    userCreatedErrorText: "Failed to create service user",
    detailsAndStatusErrorText:
      "Failed to update service user details and status",
    detailsErrorText: "Failed to update service user details",
    statusErrorText: "Failed to update service user status",
    expirationDatePlaceholder: "Click and choose date",
  },
};

export const addServiceUserDrawerModalPtBr = {
  [pageNameKey]: {
    addServiceUserTitle: "Adicionar usuário da API",
    serviceUserUsernameLabel: "Nome de usuário do serviço",
    serviceUserUsernameInputPlaceholder: "Digite o nome de usuário do serviço",
    serviceUserNameLabel: "Nome",
    serviceUserNameInputPlaceholder: "Digite o nome",
    serviceUserDescriptionLabel: "Descrição",
    serviceUserDescriptionInputPlaceholder: "Digite a descrição",
    createServiceUserButtonText: "Criar usuário de serviço",
    cancelButtonText: "Cancelar",
    rolesWarningText: "Atribua pelo menos uma função ao usuário de serviço.",
    inputsCheckWarningText: "Corrija os seguintes campos",
    userCreatedSuccessText: "Usuário de serviço criado com sucesso",
    userCreatedErrorText: "Falha ao criar usuário de serviço",
    detailsAndStatusErrorText:
      "Falha ao atualizar os detalhes e o status do usuário de serviço",
    detailsErrorText: "Falha ao atualizar os detalhes do usuário de serviço",
    statusErrorText: "Falha ao atualizar o status do usuário de serviço",
    expirationDatePlaceholder: "Clique e escolha a data",
  },
};

export const addServiceUserDrawerModalDe = {
  [pageNameKey]: {
    addServiceUserTitle: "API-Benutzer hinzufügen",
    serviceUserUsernameLabel: "Service-Benutzername",
    serviceUserUsernameInputPlaceholder: "Service-Benutzernamen eingeben",
    serviceUserNameLabel: "Name",
    serviceUserNameInputPlaceholder: "Name eingeben",
    serviceUserDescriptionLabel: "Beschreibung",
    serviceUserDescriptionInputPlaceholder: "Beschreibung eingeben",
    createServiceUserButtonText: "Service-Benutzer erstellen",
    cancelButtonText: "Abbrechen",
    rolesWarningText:
      "Bitte weisen Sie dem Service-Benutzer mindestens eine Rolle zu.",
    userCreatedSuccessText: "Service-Benutzer erfolgreich erstellt",
    userCreatedErrorText: "Fehler beim Erstellen des Service-Benutzers",
    inputsCheckWarningText: "Bitte beheben Sie die folgenden Felder",
    detailsAndStatusErrorText:
      "Fehler beim Aktualisieren der Service-Benutzer-Details und des Status",
    detailsErrorText: "Fehler beim Aktualisieren der Service-Benutzer-Details",
    statusErrorText: "Fehler beim Aktualisieren des Service-Benutzer-Status",
    expirationDatePlaceholder: "Klicken und Datum auswählen",
  },
};

export const addServiceUserDrawerModalZhHans = {
  [pageNameKey]: {
    addServiceUserTitle: "添加API用户",
    serviceUserUsernameLabel: "服务用户名",
    serviceUserUsernameInputPlaceholder: "输入服务用户名",
    serviceUserNameLabel: "名称",
    serviceUserNameInputPlaceholder: "输入名称",
    serviceUserDescriptionLabel: "描述",
    serviceUserDescriptionInputPlaceholder: "输入描述",
    createServiceUserButtonText: "创建服务用户",
    cancelButtonText: "取消",
    rolesWarningText: "请至少为服务用户分配一个角色。",
    userCreatedSuccessText: "服务用户创建成功",
    userCreatedErrorText: "服务用户创建失败",
    inputsCheckWarningText: "请修正以下字段",
    detailsAndStatusErrorText: "更新服务用户详情和状态失败",
    detailsErrorText: "更新服务用户详情失败",
    statusErrorText: "更新服务用户状态失败",
    expirationDatePlaceholder: "点击并选择日期",
  },
};

export const addServiceUserDrawerModalIt = {
  [pageNameKey]: {
    addServiceUserTitle: "Aggiungi utente API",
    serviceUserUsernameLabel: "Nome utente ",
    serviceUserUsernameInputPlaceholder: "Inserisci il nome utente",
    serviceUserNameLabel: "Nome",
    serviceUserNameInputPlaceholder: "Inserisci il nome",
    serviceUserDescriptionLabel: "Descrizione",
    serviceUserDescriptionInputPlaceholder: "Inserisci la descrizione",
    createServiceUserButtonText: "Crea utente",
    cancelButtonText: "Annulla",
    rolesWarningText: "Assegna almeno un ruolo all'utente.",
    inputsCheckWarningText: "Correggi i seguenti campi",
    userCreatedSuccessText: "Utente creato correttamente",
    userCreatedErrorText: "Impossibile creare l'utente",
    detailsAndStatusErrorText:
      "Impossibile aggiornare i dettagli e lo stato dell'utente",
    detailsErrorText: "Impossibile aggiornare i dettagli dell'utente",
    statusErrorText: "Impossibile aggiornare lo stato dell'utente",
    expirationDatePlaceholder: "Clicca e scegli la data",
  },
};

export const addServiceUserDrawerModalEs = {
  [pageNameKey]: {
    addServiceUserTitle: "Agregar API usuario",
    serviceUserUsernameLabel: "Nombre de usuario del servicio",
    serviceUserUsernameInputPlaceholder:
      "Introduce el nombre de usuario del servicio",
    serviceUserNameLabel: "Nombre",
    serviceUserNameInputPlaceholder: "Ingresa el nombre",
    serviceUserDescriptionLabel: "Descripción",
    serviceUserDescriptionInputPlaceholder: "Introducir descripción",
    createServiceUserButtonText: "Crear usuario de servicio",
    cancelButtonText: "Cancelar",
    rolesWarningText: "Asigna al menos un rol al usuario del servicio.",
    inputsCheckWarningText: "Corrige los siguientes campos",
    userCreatedSuccessText: "Usuario de servicio creado correctamente",
    userCreatedErrorText: "No se pudo crear el usuario del servicio",
    detailsAndStatusErrorText:
      "No se pudieron actualizar los detalles y el estado del usuario del servicio",
    detailsErrorText:
      "No se pudieron actualizar los detalles del usuario del servicio",
    statusErrorText: "No se pudo actualizar el estado del usuario del servicio",
    expirationDatePlaceholder: "Haz clic y elige una fecha",
  },
};

export const addServiceUserDrawerModalNl = {
  [pageNameKey]: {
    addServiceUserTitle: "API-gebruiker toevoegen",
    cancelButtonText: "Annuleren",
    createServiceUserButtonText: "Servicegebruiker aanmaken",
    detailsAndStatusErrorText:
      "Fout bij het bewerken van de gegevens en status van de servicegebruiker",
    detailsErrorText:
      "Fout bij het bewerken van de gegevens van de servicegebruiker",
    inputsCheckWarningText: "Corrigeer de volgende velden",
    rolesWarningText: "Wijs de servicegebruiker minimaal één rol toe.",
    serviceUserDescriptionInputPlaceholder: "Beschrijving invoeren",
    serviceUserDescriptionLabel: "Beschrijving",
    serviceUserNameInputPlaceholder: "Naam invoeren",
    serviceUserNameLabel: "Naam",
    serviceUserUsernameInputPlaceholder: "Servicegebruikersnaam invoeren",
    serviceUserUsernameLabel: "Servicegebruikersnaam",
    statusErrorText:
      "Fout bij het bewerken van de status van de servicegebruiker",
    userCreatedErrorText: "Fout bij het aanmaken van de servicegebruiker",
    userCreatedSuccessText: "Servicegebruiker succesvol aangemaakt",
    expirationDatePlaceholder: "Klik en kies een datum",
  },
};

export const addServiceUserDrawerModalTr = {
  [pageNameKey]: {
    addServiceUserTitle: "API Kullanıcısı Ekle",
    cancelButtonText: "İptal etmek",
    createServiceUserButtonText: "Hizmet kullanıcısı oluştur",
    detailsAndStatusErrorText:
      "Hizmet kullanıcısı ayrıntıları ve durumu güncellenemedi",
    detailsErrorText: "Hizmet kullanıcısı ayrıntıları güncellenemedi",
    inputsCheckWarningText: "Lütfen aşağıdaki alanları düzeltin",
    rolesWarningText: "Lütfen hizmet kullanıcısına en az bir rol atayın.",
    serviceUserDescriptionInputPlaceholder: "Açıklamayı girin",
    serviceUserDescriptionLabel: "Tanım",
    serviceUserNameInputPlaceholder: "Ad girin",
    serviceUserNameLabel: "İsim",
    serviceUserUsernameInputPlaceholder: "Hizmet kullanıcı adını girin",
    serviceUserUsernameLabel: "Hizmet kullanıcı adı",
    statusErrorText: "Hizmet kullanıcısı durumu güncellenemedi",
    userCreatedErrorText: "Hizmet kullanıcısı oluşturulamadı",
    userCreatedSuccessText: "Hizmet kullanıcısı başarıyla oluşturuldu",
    expirationDatePlaceholder: "Tıklayın ve tarihi seçin",
  },
};
